document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('#mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
      menu.hidden = !open;
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'メニューを開く');
    }));
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const shop = document.querySelector('#shop');
  const price = shop && shop.querySelector('.price');
  if (!shop || !price) return;
  const bar = document.createElement('aside');
  bar.className = 'mobile-purchase-bar';
  bar.setAttribute('aria-label', '商品購入へのショートカット');
  const info = document.createElement('div');
  const variant = document.createElement('small');
  variant.textContent = 'Apricot / フード付き';
  const amount = document.createElement('strong');
  const sourceMoney = price.querySelector('.money-value');
  if (sourceMoney) amount.append(sourceMoney.cloneNode(true));
  else amount.textContent = price.childNodes[0].textContent.trim();
  const tax = document.createElement('small');
  tax.textContent = '税込';
  amount.append(tax);
  info.append(variant, amount);
  const link = document.createElement('a');
  link.className = 'button';
  link.href = '#shop';
  link.textContent = '商品・購入はこちら →';
  bar.append(info, link);
  document.body.append(bar);
  const form = shop.querySelector('.purchase-form');
  const footer = document.querySelector('.footer');
  let formVisible = false, footerVisible = false;
  const update = () => { bar.hidden = formVisible || footerVisible || !!document.querySelector('input:focus,textarea:focus,select:focus'); };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.target === form) formVisible = entry.isIntersecting; if (entry.target === footer) footerVisible = entry.isIntersecting; });
    update();
  }, { threshold: 0 });
  if (form) observer.observe(form);
  if (footer) observer.observe(footer);
  document.addEventListener('focusin', update);
  document.addEventListener('focusout', () => requestAnimationFrame(update));
});
